export default "__VITE_ASSET__D5uXIyO0__"